<template>
    <div class="make-policy-wrapper">
        <van-nav-bar
            title="决策支持"
            left-text="应用"
            left-arrow
            @click-left="onClickLeft"
        >
        </van-nav-bar>
        <section class="main-wrapper">
            <div class="box-wrapper">
                <div class="nav-box">
                    <ul class="nav-wrapper">
                        <template v-for="(item, index) in navData">
                            <li
                                class="nav-item"
                                v-if="item.showNav"
                                :class="{'item-checked':activeIndex==index}"
                                :key="`nav_${index}`"
                                @click="toggletab(index,item.name)"
                            >
                                <div class="item-img">
                                    <img v-if="activeIndex===index" :src="item.highlight" alt="">
                                    <img v-else :src="item.normal" alt="">
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>

                <!-- <transition> -->
                <!-- <keep-alive> -->
                <component :is="currentView"></component>
                <!-- </keep-alive> -->
                <!-- </transition> -->
            </div>
        </section>
    </div>
</template>

<script>
import liangView from './liangView.vue';
import jiaView from './jiaView.vue';
import kuanView from './kuanView.vue';
import benView from './benView.vue';
import liView from './liView.vue';
export default {
    data() {
        return {
            currentView: 'liangView',
            activeIndex: 0,
            navData: [
                {
                    name: 'liangView',
                    normal: require('@/assets/images/home/liang_normal.png'),
                    highlight: require('@/assets/images/home/liang_highlight.png'),
                    showNav: true,
                },
                {
                    name: 'jiaView',
                    normal: require('@/assets/images/home/jia_normal.png'),
                    highlight: require('@/assets/images/home/jia_highlight.png'),
                    showNav: this.$store.state.versionMark === '2',
                },
                {
                    name: 'kuanView',
                    normal: require('@/assets/images/home/kuan_normal.png'),
                    highlight: require('@/assets/images/home/kuan_highlight.png'),
                    showNav: this.$store.state.versionMark === '2',
                },
                {
                    name: 'benView',
                    normal: require('@/assets/images/home/ben_normal.png'),
                    highlight: require('@/assets/images/home/ben_highlight.png'),
                    showNav: this.$store.state.versionMark === '2',
                },
                {
                    name: 'liView',
                    normal: require('@/assets/images/home/li_normal.png'),
                    highlight: require('@/assets/images/home/li_highlight.png'),
                    showNav: this.$store.state.versionMark === '2',
                },
            ],
        };
    },
    components: {
        liangView,
        jiaView,
        kuanView,
        benView,
        liView,
    },

    methods: {
        toggletab(index, name) {
            this.currentView = name;
            this.activeIndex = index;
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
    },
};
</script>

<style lang="stylus">
.make-policy-wrapper
    width 100%
    height 100%
    display flex
    flex-direction column
    .main-wrapper
        flex 1
        overflow hidden
        .box-wrapper
            height 100%
            // padding 15rpx
            background #F0F0F0
            overflow-y auto
            .nav-box
                background #ffffff
                overflow hidden
                .nav-wrapper
                    margin 15rpx
                    height 80rpx
                    display flex
                    box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.16);
                    background #ffffff
                    .nav-item
                        flex 1
                        display flex
                        justify-content center
                        align-items center
                        &.item-checked
                            position relative
                            .item-img
                                width 50rpx
                                height 50rpx
                            &::after
                                content ''
                                width 0
                                height 0
                                border 10rpx solid transparent
                                border-top-color #fff
                                position absolute
                                left 50%
                                margin-left -10rpx
                                bottom -18rpx
                        .item-img
                            width 40rpx
                            height 40rpx
                            img
                                width 100%
                                height 100%


</style>

